import React from 'react';

export const GoogleImageResultIcon = (): React.JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15 13.44V2.56C15 1.7 14.3 1 13.444 1H2.556C1.7 1 1 1.7 1 2.56V13.44C1 14.3 1.7 15 2.556 15H13.444C14.3 15 15 14.3 15 13.44ZM5.278 9.17L7.222 11.51L9.944 8L13.444 12.67H2.556L5.278 9.17Z"
			fill="#EA4336"
		/>
	</svg>
);
